import { render } from "./CoinRow.vue?vue&type=template&id=5f47d182"
import script from "./CoinRow.vue?vue&type=script&lang=js"
export * from "./CoinRow.vue?vue&type=script&lang=js"

import "./CoinRow.vue?vue&type=style&index=0&id=5f47d182&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__